// extracted by mini-css-extract-plugin
export default {"containerNCM":"ncmViewContainer_containerNCM__xW+-3","botoes":"ncmViewContainer_botoes__h1Stx"};